export const en = {
  language: "English",
    "general": {
        "Rights":"All Rights Reserved",
        "nanoSoft":"NanoSoft",
        "home":"Home",
        "about":"About Us",
        "services":"Services",
            "wordpress":"Wordpress",

        "contact":"Contact Us",
        "aboutParag":"Nanosoft is a software development company in Alexandria Egypt, which provides its customers with a full range of software services with a focus on web development, web design, mobile application development and software testing",
        "quickLinks":"Quick Links",
        "ourServices":"Our Services ",
        "websiteDevelopment":"Website Development",
        "appDeveloper":"Application Development ",
            "wordpressText":"If you are planning to launch your online store on WordPress, this is the right place to start. At Nanosoft, we will prepare a complete store for you that will take the hassle out of the initial setup until you are ready to sell with confidence and a respectable appearance that befits your project.",
"appDesc":"Mobile app development and design helps you reach your customers easily. With most people using smartphones daily, apps have become an effective way to increase engagement and sales. We provide you with concept development, planning, requirements definition, and professional programming to deliver your app to the highest quality.",
        "userExp":"UX/UI",
        "aboutDes":"We strive to achieve the best results in all the fields we offer and at the highest level through a professional and specialized team working to combine his efforts, expertise and talents to be used to provide the best services and achieve the goals and objectives of customers where we provide our services to all countries of the world at prices studied to suit everyone",
        "istanbul":"Alexandria",
        "turkey":"Epypt",
    "portfolio":"portfolio",


      "Readytoarchitectyournextbreakthrough":"Ready to architect your next breakthrough?",
  "GetAFreeConsultation":"Get A Free Consultation",
  "allProjects": "All Projects",
  "aiProjects": "AI Projects",
  "webInfrastructure": "Web Infrastructure",
  "mobile": "Mobile",
  "systems": "Systems",
  "interactiveVideos": "Interactive Videos",
  "portfolioParagraph":"We build the invisible architecture that powers the digital frontier. From high-availability infrastructure to neural integration, our works define the standard of modern software engineering.",
      "portfolioTitle":"ENGINEERING PORTFOLIO.",
      "Execution":"Precise Execution",
"view":"View",
  videoDesc: "Designed an immersive interactive video experience that boosts engagement and keeps users actively exploring content.",
  attendanceSystemDesc: "Developed a reliable attendance system with real-time synchronization, reducing manual errors by over 80%.",
  restaurantSystemDesc: "Developed a smart restaurant management system for orders, tables, and delivery operations.",
  policeAcademyDesc: "Developed a digital platform for the Police Academy in Oman.",
  aiAcademyDesc: "Developed an academy platform integrated with an AI chatbot.",
  universityDesc: "Developed a modern university platform for Arab Open University in Oman.",
  storeDesc: "Developed a professional online store with a modern user experience.",
  realEstateDesc: "Developed a real estate platform for showcasing properties and projects.",
  marriageAppDesc: "Developed a modern marriage and social networking mobile application.",

        "webDesc":"The websites have now become the first gateway for companies and businesses, which makes the customer take serious steps for cooperation. This is why NanoSoft Company specializes in designing and programming websites in Egypt in particular and in all Arab and Western countries in general.",
        "userDesc":"We offer prototype service and design of mobile application interfaces and websites for web and mobile products. We also focus on delivering an exceptional customer experience, with a talented team specializing in the design of mobile application interfaces and websites.",
        "vision":"Our Vision",
        "visionDesc":"NanoSoft Company was established on the leadership and development of creative ideas worldwide to be an entity that pushes customers to complete professionalism in the work according to a team of engineers specialized in all areas of the Internet and at the highest level here we gathered and gathered our talents to meet all customer requests on the advanced foundations of our business",
        "goal":"Our Goal",
        "goalDesc":"To become one of the leading companies in the field of real estate services.",
        "message":"Our Message",
        "messageDesc":"We built this company on the basis of pure creativity. We aspire to excellence in all aspects of our services in order to satisfy customers and feel our achievement on the ground today and tomorrow you will find creativity manifested in every work we put our name on it this covenant that we adhere to before ourselves and in front of you ",
        "value":"our Value",
        "valueDesc"  :"To contribute to the renaissance and development that our country is witnessing by providing distinguished and unique services and assisting in the development of our society and the satisfaction of our customers.",
        "headerTitle":"Websites and  Mobile Applications",
        "headerPara":"Creating all types of applications in an agile approach while focusing on customers’ requirements and clear UI/UX.",
         "coursesTitle":"Courses",
         "partnersTitle":"Partners ",
             "Growth":"Our Company Growth",
                 "project":"Projects",
                 "countries":"Countries",
                                      "ourfeatures":"our Features",
                                                           "featureone":"Our team is ready to answer all your questions at no extra charge.",
                     "featureTwo":"We provide step-by-step assistance with no additional cost.",
                     "featureThree":"Whether you’re a new or existing customer, our support is always free.",
                                          "networkSecurty":"Network Security"







    }
}